// extracted by mini-css-extract-plugin
export default {"cookieConsentFlow":"lm-1test-cookie-consent-flow-wrapper_cookieConsentFlow__fNcDA"};